import React, {Component} from 'react';
import {translate} from 'react-i18next';
import RaisedButton from 'material-ui/RaisedButton';
import swal from 'sweetalert';
import ModalPhenotype from '../../results_donation/components/ModalPhenotype';
import PatientData from '../../offers/components/PatientData';
import moment from 'moment';
import {Table} from 'react-bootstrap';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ContentAdd from 'material-ui/svg-icons/content/add';
import {bin} from 'react-icons-kit/icomoon/bin';
import SvgIcon from 'react-icons-kit';
import Notifications, {notify} from 'react-notify-toast';
import Inputmask from 'inputmask';
import MaskedFormControl from 'react-bootstrap-maskedinput';
import $ from 'jquery';

import {AsyncTypeahead} from 'react-bootstrap-typeahead';
import ModalCenter from '../../generics/modalCenter';

var Config = require('../../../config');

class EntryUnits extends Component{
	constructor(props){
		super(props);

		this.handleChange = this.handleChange.bind(this);
		this.onReturn = this.onReturn.bind(this);
		this.selectFieldHandle = this.selectFieldHandle.bind(this);
		this.setInfoPatient = this.setInfoPatient.bind(this);
		this.clearPatientSearch = this.clearPatientSearch.bind(this);
		this.onSave = this.onSave.bind(this);
		this.addAnaliticalTest = this.addAnaliticalTest.bind(this);
		this.deteleTest = this.deteleTest.bind(this);
		this.dateCompare = this.dateCompare.bind(this);
		this.addToList = this.addToList.bind(this);
		this.getNextNumber = this.getNextNumber.bind(this);
		this.clear = this.clear.bind(this);
		this.getAnaliticalTest = this.getAnaliticalTest.bind(this);
		this.deleteEntry = this.deleteEntry.bind(this);
		this.onFinish = this.onFinish.bind(this);
		this.getLectina = this.getLectina.bind(this);
		this.onDateChange = this.onDateChange.bind(this);
		this.dateEntryCompare = this.dateEntryCompare.bind(this);
		this.addCenter = this.addCenter.bind(this);
		this.getHealthFacilities = this.getHealthFacilities.bind(this);
		this.SetPhenotypesAntibodies = this.SetPhenotypesAntibodies.bind(this);

		this.state = {
			list_donation_type: [],
			donation_type_id:"",
			show_patient:false,
			blood_group: [],
			group_rh:"",
			national_centers:[],
			national_center_id:"",
			relationships:[],
			relationship:"",
			biometrics:[],
			require_phen: "",
			origin_list:[],
			origin_id:"",
			components:[],
			component_id:"",

			patient_lastname1:"",
			patient_lastname2:"",
			patient_name:"",
			lookup_group:"",
			lookup_rh:"",
			person_patient_id:"",
			rh_group:"",
			observations:"",
			relationship:"",
			facility_section_id:"",
			national_center_id:"",
			national_name:"",
			no_file:"",
			disablePatient:false,
			patient_id:"",

			entry_date:"",
			donation_date:"",
			volumen:"",
			unit_number:"",
			caducidad:"",
			observations_unit:"",
			names:"",
			lastname1:"",
			lastname2:"",
			component_number:"00",
			origin_unit_number:"",
			blood_component_list:[],
			next_number:{next_value:"", unit_number:""},
			analitical_test_list: [],
			other_test:[],
			test_id:"",
			value_test:"",
			table_other_test:[],
			add_other_test:false,
			unit_id:"",
			hour:"23:59",
			folio:"",
			units_list:[],
			requestedSelected:[],
			indice:-1,
			isLoading:false,
			don_edit_don_num:{},
			lectina:"",
			disable_lect:true,
			du:"",
			lectina_list:[],
			du_list:[],
			disable_du:true,
			hoy:moment().format('YYYY-MM-DD'),
			max_length:"4",
			user_add_center:"",
			unit_entries_has_phenotypes:[]
		}
	}

	componentDidMount(){
		$(document).on('blur', '.input-date', (e)=>{
			var date = moment(e.target.value, 'DD/MM/YYYY').format('YYYY-MM-DD');
			
			if(e.target.value !== ""){
				if(date === 'Invalid date' || date === 'Fecha inválida'){
					swal('Error', 'Debes ingresar un valor válido. El campo está incompleto o contiene una fecha no válida.', 'error');

					$('#'+e.target.id).addClass('error');

					setTimeout(()=>{
						$('#'+e.target.id).val('');
						e.target.value = "";
						
						this.dateHandleChange(e);
					}, 3500)
				}else{
					$('#'+e.target.id).removeClass('error');
				}
			}else{
				$('#'+e.target.id).removeClass('error');
			}
		});

		var selector = document.getElementById("hour");
		var im = new Inputmask("--:--");
		im.mask(selector);
		
		this.props.waiting.handleShow('Cargando...');
		this.getBiometrict();
		if(this.props.match.params.id !== undefined){
			this.getPruebasAnaliticas();
		}

		this.getLectina('LEC');

		fetch(Config.default.apiGateway.URL+'analitical_test/values?code=DU',{ 
			method: 'get',
			headers: new Headers({
			   'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
			   'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(res => {
            if(res.ok){
              return res.json();
            }else{
              res.text().then(function(result) {
                swal('¡Error!', result, 'error');
              });
            }})
		.then(response => {
			if(response !== undefined){
				this.setState({
					du_list:response,
				});
			}
		});

		fetch(Config.default.apiGateway.URL+'offers?option=date',{ 
			method: 'get',
			headers: new Headers({
			   'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
			   'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(res => {
            if(res.ok){
              return res.json();
            }else{
              res.text().then(function(result) {
                swal('¡Error!', result, 'error');
              });
            }})
		.then(response => {
			var aux = response.split('|');
			//var date_parts = aux[0].split('/');
			this.setState({
				entry_date:aux[0],
				//entry_date:date_parts[2]+'-'+date_parts[1]+'-'+date_parts[0],
			});
		});

		fetch(Config.default.apiGateway.URL+'functional_criterion?code=DON_EDIT_DON_NUM&x=', {
			method: 'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					don_edit_don_num: response.value
				});
			}
		});

		fetch(Config.default.apiGateway.URL+'functional_criterion?code=USER_ADD_CENTER&x=', {
			method: 'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					user_add_center: response.value
				});
			}
		});

		fetch(Config.default.apiGateway.URL+'functional_criterion?code=DIS_REQUIRE_PHEN&x=', {
			method: 'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					require_phen: response.value
				});
			}
		});

		fetch(Config.default.apiGateway.URL+'donation_type/actives', {
			method: 'get',
			headers: new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response =>{
			if(response !== undefined){
				this.setState({list_donation_type: response});
			}
		});

		fetch(Config.default.apiGateway.URL+'lookups?type=blood_group_rh', {
			method: 'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response=>{
			if(response !== undefined){
				this.setState({
					blood_group: response
				});
			}
		});

		this.getHealthFacilities();

		fetch(Config.default.apiGateway.URL+'lookups?type=blood_component_type&option=actives&order=false', {
			method: 'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response=>{
			if(response !== undefined){
				this.setState({
					components: response
				});
			}
		});

		fetch(Config.default.apiGateway.URL+'blood_component/order_by?option=name', {
			method: 'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					blood_component_list: response
				})

				if(this.props.match.params.id !== undefined){
					this.getValues();						
				}
			}
		})

		if(this.props.match.params.id === undefined){
			this.getNextNumber();	
		}
		
		this.getAnaliticalTest();

	}

	getLectina(code){
		fetch(Config.default.apiGateway.URL+'analitical_test/values?code='+code,{ 
			method: 'get',
			headers: new Headers({
			   'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
			   'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(res => {
            if(res.ok){
              return res.json();
            }else{
              res.text().then(function(result) {
                swal('¡Error!', result, 'error');
              });
            }})
		.then(response => {
			if(response !== undefined && response !== null){
				this.setState({
					lectina_list:response,
				});
			}else{
				if(code !== 'LECTINA'){
					this.getLectina('LECTINA');	
				}
				
			}	
		});
			
	}

	getValues(){
		setTimeout(()=>{
			fetch(Config.default.apiGateway.URL+'unit_entries/'+this.props.match.params.id,{
				method: 'get',
				headers: new Headers({
					'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
					'Accept'		: 'application/json',
					'Content-Type'	: 'application/json'
				})
			}).then(res => {
				this.props.waiting.handleClose();

				if(res.ok){
					return res.json();
				}else{
					res.text().then((msg)=>{
						swal('Error', msg, 'error');
					});
				}
			}).then(response => {
				if(response !== undefined){

					var index = this.state.origin_list.findIndex(obj => 
						obj.id === response.unit_entries.national_center_origin_id
					);

					var unit_phenotypes = [];
					response.unit_entries_has_phenotypes.forEach((res)=>{
						if(res.antibody_code !== null){
							unit_phenotypes.push({
								antibody_code: res.antibody_code,
								result:res.result
							});
						}

						if(res.phenotype_code !== null){
							unit_phenotypes.push({
								phenotype_code: res.phenotype_code,
								result:res.result
							});
						}
						
					})
				
					this.setState({
						unit_entries_has_phenotypes: unit_phenotypes,
						component_id: response.unit.blood_component_id,
						caducidad: moment(response.unit.caducidad, 'YYYY-MM-DD').format('DD/MM/YYYY'),
						component_number: response.unit.component_number,
						unit_number: response.unit.unit_number,
						volumen: response.unit.volume,
						donation_date: moment(response.unit_entries.donation_date, 'YYYY-MM-DD').format('DD/MM/YYYY'),
						donation_type_id: response.unit_entries.donation_type_id,
						entry_date: moment(response.unit_entries.entry_date, 'YYYY-MM-DD').format('DD/MM/YYYY'),
						origin_id: response.unit_entries.national_center_origin_id,
						names: response.unit_entries.names,
						lastname1: response.unit_entries.lastname1,
						lastname2: response.unit_entries.lastname2,
						observations_unit: response.unit_entries.observations,
						origin_unit_number: response.unit_entries.origin_unit_number,
						unit_id: response.unit_entries.unit_id,
						group_rh: response.unit_entries.group+' '+response.unit_entries.rh,
						equivalet_unit:response.unit_entries.equivalent_units,
						indice:index,
						requestedSelected:[this.state.origin_list[index]],
						folio:response.unit_entries.folio,
						lectina:response.lectina,
						du:response.du
					});

					if(response.unit_entries.group.toUpperCase() === 'A' || response.unit_entries.group.toUpperCase() === 'AB'){
						this.setState({disable_lect:false});
					}else{
						this.setState({disable_lect:true, lectina:''});
					}

					if(response.unit_entries.rh.toUpperCase() === 'NEGATIVO'){
						this.setState({disable_du:false});
					}else{
						this.setState({disable_du:true, du:''});
					}

					if(response.person !== null){
						this.setState({
							show_patient: true,
						});
						this.setInfoPatient(response);
					}

					

					if(response.unit_entries_has_biometrics.length > 0){
						response.unit_entries_has_biometrics.map((bio)=>{
							if(document.getElementById('biometric_'+bio.biometrics_id) !== null){
								document.getElementById('biometric_'+bio.biometrics_id).value = bio.value;
							}
						});
					}

					this.state.analitical_test_list.map((test)=>{
						var index = response.analitical_test_required.findIndex(obj => 
							obj.analitical_test_id === test.analitical_test.id
						);

						if(index === -1){
							test.checkbox.checked = false;
						}
					});
					this.forceUpdate();

					response.other_analitical_test.map((other)=>{
						this.setState({
							test_id: other.analitical_test.id.toString(),
						});

						this.addAnaliticalTest();
					})

					this.addToList(response)
				}
			});
		}, 500);
	}

	getAnaliticalTest(){
		fetch(Config.default.apiGateway.URL+'analitical_test?id=0&option=required_nom', {
			method: 'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined && response !== null){
				response.map((r, i)=>{
					r.checkbox = {
						id: 'check_test_'+r.analitical_test.id,
						checked: true
					}
				});

				this.setState({analitical_test_list: response});
			}
		});
	}

	getNextNumber(){
		fetch(Config.default.apiGateway.URL+'donations/get_next_number?health_facilities_id='+
			sessionStorage.getItem('health_facilities_id')+'&sample_type=DONOR', {
			method: 'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({next_number: response, unit_number: response.unit_number});
			}
		});
	}

	validString(value){
		return new RegExp("^[a-zA-Záéíóú´ ./ñÑ]+$").test(value);
	}

	
	getHealthFacilities(){
		fetch(Config.default.apiGateway.URL+'health_facilities?option=distribution', {
			method: 'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response=>{
			if(response !== undefined){
				this.setState({
					origin_list: response
				});
			}
		});
	}

	handleChange(e){
		if(e.target.id.indexOf('check_') !== -1){
			var id = e.target.id;
			var check = e.target.checked;

			this.state.analitical_test_list.map((item)=>{
				
				return item.checkbox.id === id ?
					item.checkbox.checked ?
						item.checkbox.checked = false
					: item.checkbox.checked = true
				: null
			});

			this.forceUpdate();
		}else if(e.target.name === 'names' || e.target.name === 'lastname1' || e.target.name === 'lastname2'){
			if(e.target.value === ""){
				this.setState({
			      [e.target.name]: e.target.value
			    });		
			}
			if(this.validString(e.target.value)){
				this.setState({
			      [e.target.name]: e.target.value
			    });		
			}
		}else{
			if(e.target.name === 'component_number'){
				if(e.target.value.length < 3){
					this.setState({
						[e.target.name]: e.target.value
					});	
				}
			}else if(e.target.name === 'volumen'){
				if(e.target.value === ""){
					this.setState({[e.target.name]: e.target.value})
				}

				if(e.target.value.length < 5){
					let regex = new RegExp("^[0-9]+$");

					if(regex.test(e.target.value)){
						this.setState({[e.target.name]: e.target.value})
					}
					
				}
			}else if(e.target.name === 'donation_date'){
				
				if(e.target.value === ""){
					this.setState({
						[e.target.name]: e.target.value
					});
					this.reset_date_native(e.target.name)
				}else{
					if(moment(this.state.hoy) >= moment(e.target.value) && moment('1900-01-01') <= moment(e.target.value)){
						this.setState({
							[e.target.name]: e.target.value
						});		
					}
				}
				
				
				
			}
			else{
				this.setState({
					[e.target.name]: e.target.value
				});	
			}

			if(e.target.value !== ""){
				var control = document.getElementById(e.target.name);
				control.classList.remove('error');
			}

			if(e.target.name === 'donation_type_id'){

				var index = this.state.list_donation_type.findIndex(obj=>(obj.donation_type.id === parseInt(e.target.value, 10)));
				if(index !== -1){
					
					if(this.state.list_donation_type[index].donation_type.patient_required !== 0 && this.state.list_donation_type[index].donation_type.patient_required !== null){
						this.setState({show_patient: true});
						this.getNationalCenter();
						this.getRelationships();
					}else{
						this.setState({show_patient: false});
					}
				}else{
					this.setState({show_patient: false});
				}
			}else if(e.target.name === 'add_test'){
				if(e.target.checked){
					this.getPruebasAnaliticas();
					

				}else{
					this.setState({
						add_other_test:false
					});
				}
			}else if(e.target.name === 'group_rh'){
				var grupo = e.target.value.split(' ')[0];
				var rh = e.target.value.split(' ')[1];

				if(e.target.value !== ''){
					if(grupo.toUpperCase() === 'A' || grupo.toUpperCase() === 'AB'){
						this.setState({disable_lect:false});
					}else{
						this.setState({disable_lect:true, lectina:''});
					}

					if(rh.toUpperCase() === 'NEGATIVO'){
						this.setState({disable_du:false});
					}else{
						this.setState({disable_du:true, du:''});
					}
				}else{
					this.setState({disable_du:true, du:'',disable_lect:true, lectina:''});
				}
			}
		}	


		if(e.target.name === "hour"){
			var hour = moment(e.target.value, 'h:mm a');
			if(hour.format('H:mm') === "Invalid date" || e.target.value.indexOf('-') !== -1){
				document.getElementById(e.target.id).classList.add("error");
				document.getElementById(e.target.name).style.borderColor = "red";
			}else{
				document.getElementById(e.target.name).style.borderColor = "#ccc";
				document.getElementById(e.target.id).classList.remove("error");
			}
		}	
	}

	getNationalCenter(){
		fetch(Config.default.apiGateway.URL+'national_centers?option=offers&health_facility='+
			sessionStorage.getItem('health_facilities_id'), {
			method: 'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response=>{
			if(response !== undefined){
				this.setState({
					national_centers: response
				});
			}
		});
	}

	getRelationships(){
		fetch(Config.default.apiGateway.URL+'lookups?type=FAMILIAR_RELATIONSHIP&option=actives&order=true', {
			method: 'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response=>{
			if(response !== undefined){
				this.setState({
					relationships: response
				});
			}
		});
	}

	//get biometricos
	getBiometrict(){
		fetch(Config.default.apiGateway.URL+'biometrics?option=biometrics_for_entry_units&sex='+this.state.sex,{ 
	        method: 'get',
	        headers: new Headers({
	           'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
	           'Accept': 'application/json',
	            'Content-Type': 'application/json',
	        })
	    })
	    .then(response => response.json())
	    .then(response => {
	      for (var i = 0; i < response.length; i++) {
	      	response[i].offer_id = this.state.offer_id;
	      };
	      this.setState({biometrics: response});
	      setTimeout(function() { //Start the timer
		  	for(var j =0;j<response.length;j++){
		  		if(document.getElementById('biometric_'+response[j].id) !== null){
			  		document.getElementById('biometric_'+response[j].id).required = response[j].required;
		  		}
			  		
		  	}
		  }.bind(this), 500)
	      
	    })
	}

	calculateValuesBIO(e){
		var control = "";

		this.validateRangeBiometric(e.target.id, e.target.value);
		for (var i = 0; i < this.state.biometrics.length; i++) {
			if (this.state.biometrics[i].data_type === "BIO_D_CALCULATED") {
				var str = (this.state.biometrics[i].formula).split('&');
				var value = this.getTerms(str,'biometric_');
				control = document.getElementById('biometric_'+this.state.biometrics[i].id).value
				if(value !== ""){
					if(control.required && control.className.includes('error')){
						control.classList.remove('error');
					}
					control.value = value;
					control.classList.remove('error');
				}else{
					control.classList.add('error');
					control.value = "";
				}
			};
		};
		if(e.target.value.indexOf('.') !== -1){
			this.setState({max_length: "5"});
		}else{
			this.setState({max_length: "4"});
		}

		if(e.target.id !== null){
			control = document.getElementById(e.target.id);
			if(e.target.value !== ""){
				if(control.required && control.className.includes('error')){
					control.classList.remove('error');
				}else if(control.className.includes('error')){
					control.classList.remove('error');
				}
			}else{
				control.classList.add('error');
			}
		}
	}

	validateRangeBiometric(id, value){
		for(var i =0; i < this.state.biometrics.length;i++){
			if(id.toString() === 'biometric_'+this.state.biometrics[i].id.toString()){
				if(this.state.biometrics[i].ranges_validation){//Si el biometrico tiene rango de valores
					var aux = parseFloat(value);
					if(this.state.sex === "HOMBRE"){//Valores para hombre
						//Desmarcar el color rojo del control
						if(aux >= this.state.biometrics[i].low_rank_male && aux <= this.state.biometrics[i].high_rank_male){
							document.getElementById(id).style.borderColor = "#ccc";
						}else{//Si esta fuera de rango marcar el control de color rojo
							document.getElementById(id).style.borderColor = "red";
						}
					}else{//Valores para mujer
						//Desmarcar el color rojo del control
						if(aux >= this.state.biometrics[i].low_rank_female && aux <= this.state.biometrics[i].high_rank_female){
							document.getElementById(id).style.borderColor = "#ccc";
						}else{//Si esta fuera de rango marcar el control de color rojo
							document.getElementById(id).style.borderColor = "red";
						}
					}
				}	
			}
		}
	}

	validateInput(e) {
	    const re = /^[-+]?$/;
	    if (e.key === "Enter") {
      		e.preventDefault(); // Prevent form submission if button present
      		
      		const form = e.target.form;
      		const index = Array.prototype.indexOf.call(form, e.target);
      		if(form.elements[index + 1] !== undefined){
      			if(form.elements[index + 1].getAttribute("disabled") !== undefined){
    				if(form.elements[index + 1].getAttribute("disabled") === null){
    					form.elements[index + 1].focus();
    				}else if(form.elements[index + 1].getAttribute("disabled") === ""){
    					form.elements[index + 2].focus();
    				}
    			}
      		}
    	
		    if (!re.test(e.key)) {
		      e.preventDefault();
		    }
		}
  	}

  	onReturn(){
		this.props.history.push('/entry_units');
	}

	openModalPhenotype(e, modal){
		e.preventDefault();
		this.modal_phenotype.handleShow('', '', '', modal, 'distribution');
	}

	selectFieldHandle = (id, name, event, index, value) => {
		this.setState({[event.target.name]:event.target.value});
	}

	setInfoPatient(item){
		if(item !== "" && item !== undefined)
		{
			this.setState({
				patient_name:item.person.names,
				patient_lastname1:item.person.lastname1,
				patient_lastname2:item.person.lastname2,
				patient_id:item.patient.id,
		    	person_patient_id:item.person.id,
		    	relationship:item.patient.relationship,
		    	observations:item.patient.observations,
		    	national_name:item.patient.national_name,
		    	no_file:item.patient.number
			});

			if (item.person.lookup_group && item.person.lookup_rh) {
				this.setState({
					lookup_group:item.person.lookup_group,
				    lookup_rh:item.person.lookup_rh
				});

				if (this.state.lookup_rh === "POSITIVO") {
					this.setState({
						rh_group: item.person.lookup_group +' +',
					});
				}else {
					this.setState({
						rh_group: item.person.lookup_group +' -',
					});
				};
			}else{
				this.setState({rh_group: "",});
			}

			//ver si es national center
			if (item.patient.national_center_id) {
				this.setState({hemored:false});

				this.setState({national_center_id:item.patient.national_center_id});

			} else{//hemored
				this.setState({hemored:true});

				if (item.patient.facility_section_id) {
					this.setState({facility_section_id:item.patient.facility_section_id});

					this.offer.searchHealthFacility(item.patient.facility_section_id);
				};
			};

			if(this.props.match.params.id === undefined){
				this.patient.setState({disablePatient:true});
			}
			
		}
	}

	autocompleteHandle = (name,value) => {
		this.setState({[name]:value});
	}

	clearPatientSearch(){
		this.setState({
			patient_lastname1:"",
			patient_lastname2:"",
			patient_name:"",
			lookup_group:"",
			lookup_rh:"",
			person_patient_id:"",
			observations:"",
			relationship:"",
			facility_section_id:"",
			national_center_id:"",
			national_name:"",
			no_file:"",
		});

		if(this.patient !== undefined && this.patient !== null){
			this.patient.setState({disablePatient:false});
		}
	}

	SetPhenotypesAntibodies(item){
		var values = this.state.unit_entries_has_phenotypes;

		var index = values.findIndex(obj => {
			if(obj.phenotype_code !== undefined){
				return obj.phenotype_code === item.phenotype_code
			}
			
		});

		if(index === -1){
			index = values.findIndex(obj => {
				if(obj.antibody_code !== undefined){
					return obj.antibody_code === item.antibody_code
				}
			});

			if(index === -1){
				values.push(item)
			}else{
				values[index] = item;
			}
		}else{
			values[index] = item;
		}

	}

	onSave(){
		if(this.isValidForm()){
			var date = this.isValidDate();
			
			if(date === ""){
				if(!this.dateEntryCompare()){
					if(!this.dateCompare()){
						var obj = {};
						var lectina ="", du='', valida = '';
						var entry_date = moment(this.state.entry_date, 'DD/MM/YYYY');
						var donation_date = moment(this.state.donation_date, 'DD/MM/YYYY');
						var caducidad = moment(this.state.caducidad, 'DD/MM/YYYY');
						var api = "";
						var method = "";
						obj.unit = {
							blood_component_id: parseInt(this.state.component_id, 10),
							volume:this.state.volumen,
							donation_date: donation_date.format('MM-DD-YYYY'),
							caducidad:caducidad.format('MM-DD-YYYY')+' '+this.state.hour,
							unit_number:this.state.unit_number,
							component_number:this.state.component_number,
							health_facilities_id: parseInt(sessionStorage.getItem('health_facilities_id'), 10),
							group:this.state.group_rh.split(' ')[0],
							rh: this.state.group_rh.split(' ')[1],
						};
						obj.lectina = this.state.lectina;
						obj.du = this.state.du;

						var biometrics = [];
						//recorrer biometricos para obternet el {id, value}
						this.state.biometrics.map((item)=>{
							biometrics.push({
								biometrics_id: parseInt(item.id, 10),
								value: document.getElementById('biometric_'+item.id.toString()).value,
							});
						});

						var analitical_results = [];
						this.state.analitical_test_list.map((ob)=>{
							if(ob.checkbox.checked){					
								analitical_results.push({
									analitical_test_id: ob.analitical_test.id,
									value: "NEGATIVO"
								});
							}
						});

						this.state.table_other_test.map((ot)=>{
							analitical_results.push({
								analitical_test_id: ot.analitical_test.id,
								value: ot.value,//document.getElementById('analitical_'+ot.analitical_test.id).value
							});
						});

						obj.unit_entries = {
							entry_date:entry_date.format('MM-DD-YYYY'),
							donation_date:donation_date.format('MM-DD-YYYY'),
							national_center_origin_id: parseInt(this.state.origin_id, 10),
							donation_type_id: parseInt(this.state.donation_type_id, 10),
							group:this.state.group_rh.split(' ')[0],
							rh:this.state.group_rh.split(' ')[1],
							observations: this.state.observations_unit,
							names:this.state.names,
							lastname1:this.state.lastname1,
							lastname2:this.state.lastname2,
							unit_entries_has_biometrics:biometrics,
							origin_unit_number: this.state.origin_unit_number,
							unit_entries_has_analitical_results:analitical_results,
							folio:this.state.folio,
							equivalent_units:this.state.equivalet_unit,
							health_facilities_id: parseInt(sessionStorage.getItem('health_facilities_id'), 10),
							unit_entries_has_phenotypes: this.state.unit_entries_has_phenotypes
						}

						if(this.state.show_patient){
							obj.person = {
								person_type:"PATIENT",
								names:this.state.patient_name,
								lastname1:this.state.patient_lastname1,
								lastname2:this.state.patient_lastname2,
								lookup_group:this.state.lookup_group,
								lookup_rh:this.state.lookup_rh,
								patient:[{
									relationship:this.state.relationship,
									obaservations:this.state.observations,
									national_center_id:parseInt(this.state.national_center_id, 10),
									national_name:this.state.national_name,
									number:this.state.no_file,
								}]
							};

							if(this.state.patient_id !== ""){
								obj.person.id = this.state.person_patient_id;
								obj.person.patient[0].id = this.state.patient_id;
							}
						}

						if(this.props.match.params.id !== undefined){
							api = 'unit_entries/'+this.props.match.params.id;
							method = 'PUT';

							obj.unit_entries.unit_id = this.state.unit_id;
							obj.unit_entries.id = parseInt(this.props.match.params.id, 10);
							obj.unit.id = this.state.unit_id;
							
						}else{
							api = 'unit_entries';
							method = 'POST';

							obj.next_value = this.state.next_number.next_value;
							obj.folio = this.state.folio;
						}

						if(this.state.lectina !== ""){
							if(this.state.group_rh.split(' ')[0].toUpperCase() !== 'A' &&
								this.state.group_rh.split(' ')[0].toUpperCase() !== 'AB'){
								lectina = 'La lectina solo es valida con grupo A ó AB\n';
							}else{
								lectina = '';
							}
						}
						if(this.state.du !== ""){
							if(this.state.group_rh.split(' ')[1].toUpperCase() !== 'NEGATIVO'){
								du += 'El valor DU solo es valido con RH NEGATIVO';
							}else{
								du = '';
							}
						}  

						var d_don = moment(this.state.donation_date, 'DD/MM/YYYY').format('YYYY-MM-DD');
						var d_caducidad = moment(this.state.caducidad, 'DD/MM/YYYY').format('YYYY-MM-DD');
						var res = d_don > d_caducidad;
						
						if(res){
							valida = 'La fecha de caducidad no puede ser menor a fecha de donación'
						}

						if(valida === ''){
							obj.health_facilities_id = sessionStorage.getItem('health_facilities_id');
							
							this.props.waiting.handleShow('Guardando...');
							fetch(Config.default.apiGateway.URL+api, {
								method: method,
								body: JSON.stringify(obj),
								headers: new Headers({
									'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
									'Accept'		: 'application/json',
									'Content-Type'	: 'application/json'
								})
							}).then(res => {
								this.props.waiting.handleClose();
								if(res.ok){
									if(method === 'PUT'){
										return 'OK';
									}else{
										return res.json();
									}
									
								}else{
									res.text().then((msg)=>{
										swal('Error', msg, 'error');
									});
								}
							}).then(response => {
								if(response !== undefined){
									swal("Correcto", "Registro guardado correctamente.", 'success');
									//this.props.history.push('/entry_units');
									obj.id = response.id;
									obj.unit_entries.id = response.id;
									this.addToList(obj);
								}
							});
							
						}else{
							swal('Error', valida, 'error');
						}

							
						
					}else{
						swal('Error', 'La fecha de caducidad no puede ser menor a la fecha de entrada', 'error');
					}
				}else{
					swal('Error', 'La fecha de donacion no puede ser mayor a la fecha de hoy', 'error');
				}
				
			}else{
				swal('Error', date, 'error');
			}
					
		}else{
			swal('Error', 'Campos incompletos', 'error');
		}			
	}

	dateEntryCompare(){
		var d_entry = moment(this.state.entry_date, 'DD/MM/YYYY').format('YYYY-MM-DD');
		var d_donation_date = moment(this.state.donation_date, 'DD/MM/YYYY').format('YYYY-MM-DD');
		var hoy = moment(this.state.hoy).format('YYYY-MM-DD');

		if(d_entry === 'Invalid date' || d_entry === 'Fecha inválida'){
			return true;
		}

		if(d_donation_date === 'Invalid date' || d_donation_date === 'Fecha inválida'){
			return true;
		}

		var res = hoy >= d_donation_date || '1900-01-01' >= d_donation_date
		
		return !res;
	}

	dateCompare(){
		var d_entry = moment(this.state.entry_date, 'DD/MM/YYYY').format('YYYY-MM-DD');
		var d_caducidad = moment(this.state.caducidad, 'DD/MM/YYYY').format('YYYY-MM-DD');

		if(d_entry === 'Invalid date' || d_entry === 'Fecha inválida'){
			return true;
		}

		if(d_caducidad === 'Invalid date' || d_caducidad === 'Fecha inválida'){
			return true;
		}

		var res = d_entry > d_caducidad;
		
		return res;
	}

	isValidForm() {
		const inputs = document.querySelectorAll('select,input');
	    let isFormValid = true;
	    
	    inputs.forEach(input => {
	    	if(input.required){
	    		if(input.id === 'requested_by' || input.id === 'requested_to'){
	    			isFormValid = this.getValidationState(input.id);
	    		}else{
	    			const isInputValid = this.showCtrlError(input.name);
			      	if (!isInputValid) {
			        	isFormValid = false;
			    	}
	    		}
	    		
			      			   
		  	}
	    });
	    
	    return isFormValid;
	}

	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);
		
		if (this.state[refName] === "") {

			if(control !== null){
				control.classList.add('error');
			}
			res = false;
		} else{
			if(control !== null){
				if(control.required && control.className.includes('error')){
					control.classList.remove('error');
				}
			}
			res = true;
		}
		

		return res;
	}

	isValidDate(){
		var entry_date = moment(this.state.entry_date, 'DD/MM/YYYY');
		var donation_date = moment(this.state.donation_date, 'DD/MM/YYYY');
		var caducidad = moment(this.state.caducidad, 'DD/MM/YYYY');

		var entryValid = entry_date.format('MM-DD-YYYY');
		var donationValid = donation_date.format('MM-DD-YYYY');
		var caducidadValid = caducidad.format('MM-DD-YYYY');

		var msg = '';
		if(entryValid === 'Invalid date' || entryValid === 'Fecha inválida'){
			msg += 'Fecha de Entrada ,';
			document.getElementById('entry_date').classList.add('error');
		}

		if(donationValid === 'Invalid date' || donationValid === 'Fecha inválida' ){
			msg += 'Fecha de Donación ,';
			document.getElementById('donation_date').classList.add('error');
		}

		if(caducidadValid === 'Invalid date' || caducidadValid === 'Fecha inválida'){
			msg += 'Fecha de Caducidad ';
			document.getElementById('caducidad').classList.add('error');
		}

		if(msg === ''){
			return msg;
		}else{
			msg += 'no válida';
			return msg;
		}
	}

	getPruebasAnaliticas(){
		fetch(Config.default.apiGateway.URL+'analitical_test?id=0&option=list',{ 
	        method: 'get',
	        headers: new Headers({
	           'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
	           'Accept': 'application/json',
	            'Content-Type': 'application/json',
	        })
	    })
	    .then(response => response.json())
	    .then(response => {
	      	this.setState({
	      		other_test: response, 
	      		add_other_test:true
	      	});
	    });
	}

	addAnaliticalTest(){
	
		if(this.state.test_id !== ''){
			var index = this.state.table_other_test.findIndex(obj => 
				obj.analitical_test.id === parseInt(this.state.test_id)
			);

			var obligado = this.state.analitical_test_list.findIndex(obj => 
				obj.analitical_test.id === parseInt(this.state.test_id)
			);

			if(index === -1 && obligado === -1){
				this.state.other_test.map((item)=>{
					 return parseInt(this.state.test_id) === item.analitical_test.id ?
						this.setState({
							table_other_test: [...this.state.table_other_test, item],
							test_id:""
						})
					: null
				})
			}else{
				if(obligado !== -1){
					swal('¡Error!', '¡La prueba se encuentra en el listado de Pruebas Obligatorias!', 'error');
				}else if(index !== -1){
					swal('¡Error!', '¡Ya ha agregado esta prueba!', 'error');
				}
				
			}
		}else{
			swal('¡Error!', '¡Debe seleccionar una prueba', 'error');
		}
	}

	deteleTest(i){
		this.state.table_other_test.splice(i, 1);
		this.forceUpdate();
	}

	addToList(obj){
		
		this.getAnaliticalTest();
		if(this.props.match.params.id === undefined){
			this.clear();
			this.clearPatientSearch();
			this.getNextNumber();
		}else{
			this.setState({units_list:[]});
		}

		var i_comp = this.state.blood_component_list.findIndex(item => 
			item.component.id === obj.unit.blood_component_id
		);


		this.setState({
			units_list: [...this.state.units_list, {
				id:obj.unit_entries.id,
				donor:obj.unit_entries.names+' '+obj.unit_entries.lastname1+' '+obj.unit_entries.lastname2,
				unit_number: obj.unit.unit_number,
				component:this.state.blood_component_list[i_comp].component.component,
				component_number:obj.unit.component_number,
				group_rh:obj.unit.group+(obj.unit.rh === 'POSITIVO' ? '+' :
					obj.unit.rh === 'NEGATIVO' ? '-' : ''),
				caducidad: moment(obj.unit.caducidad).format('DD/MM/YYYY HH:mm'),
				donation_date: moment(obj.unit.donation_date).format('DD/MM/YYYY'),
				volume:obj.unit.volume,
			}]
		})
	}

	clear(){
		this.setState({
			//folio:"",
			donation_date:"",
			donation_type_id:"",
			origin_unit_number:"",
			component_id:"",
			component_number:"00",
			group_rh:"",
			volumen:"",
			caducidad:"",
			hour:"23:59",
			observations_unit:"",
			names:"",
			lastname1:"",
			lastname2:"",
			show_patient:false,
			add_other_test:false,
			analitical_test_list:[],
			lectina:"",
			du:"",
			unit_entries_has_phenotypes:[]
		});

		document.getElementById('add_test').checked = false;

		this.state.biometrics.map( (t, index) => {
			document.getElementById('biometric_'+t.id.toString()).value = ""
		});
	}

	deleteEntry(i, id){
		swal({
	        title: '¿Está seguro?',
	        text: '¿Desea eliminar este registro?',
	        type: 'warning',
	        showCancelButton: true,
	        confirmButtonColor: '#DD6B55',
	        confirmButtonText: '¡Si, Eliminar!',
	        cancelButtonText: '¡No, Cancelar!',
	        closeOnConfirm: true,
	        closeOnCancel: true
	    },(isConfirm)=> {
	        if (isConfirm) {
	          	this.props.waiting.handleShow('Eliminando...');
				fetch(Config.default.apiGateway.URL+'unit_entries/'+id,{
					method: 'delete',
					headers: new Headers({
						'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
						'Accept'		: 'application/json',
						'Content-Type'	: 'application/json'
					})
				}).then(res => {
					this.props.waiting.handleClose();
					if(res.ok){
						return 'ok'; //res.json();
					}else{
						res.text().then((msg)=>{
							swal('Error', msg, 'error');	
						});
					}
				}).then(response => {
					if(response !== undefined){
						swal('Correcto', 'El registro se elimino correctamente.', 'success');
						this.state.units_list.splice(i, 1);
						this.forceUpdate();
						this.getNextNumber();
					}
				})
	        }
	    });
	}

	handleTypeAheadChange = name => values => {
        if(values.length > 0){
    		this.setState({
    			isLoading:false,
	            [name]: values[0].id,
	            indice:0,
				requestedSelected:values,
	        });

			document.getElementById('folio').focus();        	
        }
    }

    _handleSearch2 = (query) => {
	    this.setState({
	    	isLoading:true,
			indice:-1,
			requestedSelected:[],
	    });
	}

	onFinish(){
		if(this.state.units_list.length > 0){
			this.props.history.push('/entry_units');
		}else{
			swal('Error', 'Debe agregar por lo menos una unidad', 'error');
		}
	}

	onDateChange(e){
		this.setState({[e.target.name]: e.target.value});		
	}

	addCenter(){
		this.modal_add_center.handleShow();
	}

	render(){
		const {t} = this.props;

		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page" >
						{sessionStorage.getItem('health_facilities_name')} ->
						{t('sidebar.nav.home.MAIN')} -> 
						{t('sidebar.nav.distribution.MAIN')} ->
						Entrada de Unidades
					</h5>
				</div>

				<form noValidate>
					<div className="col-xs-12">
						<div className="col-xs-12 col-sm-4">
							<div>
								<span className="span-min">Origen</span>
							</div>
							<div style={{width:this.state.user_add_center === 'YES' ? '90%' : '100%', display:'inline-block'}}>
								<AsyncTypeahead
									/*{...this.state}*/
									labelKey={(option) => `${option.name}`}
									minLength={0}
									inputProps={{
										name:"origin_id",
										required: true,
										id:"origin_id"
									}}
									id="originId"
									options={this.state.origin_list}
									onChange={this.handleTypeAheadChange('origin_id')}
									onSearch={this._handleSearch2}
									onKeyPress={(e) => this.validateInput(e)}
									defaultSelected={this.state.origin_list.slice(this.state.indice, 1)}
									selected={this.state.requestedSelected}
									ref={ref => this._typeahead = ref}
									isLoading={this.state.isLoading}
									useCache={false}
									delay={600}
									paginationText="Mostrar mas resultados..."
								/>
							</div>
							{this.state.user_add_center === 'YES' &&
								<div style={{width:'10%', display:'inline-block', textAlign:'center'}}>
									<FloatingActionButton className="action-btn" iconStyle={{height: 20, width: 20}} mini={true} 
										onClick={this.addCenter}  >
										<ContentAdd/>
									</FloatingActionButton> 
								</div>
							}
						</div>
						<div className="col-xs-12 col-sm-1">
							<span className="span-min">Folio</span>
							<input type="text" className="form-control hour-input"  
								name="folio" id="folio" value={this.state.folio}
								onChange={this.handleChange}
								onKeyPress={(e) => this.validateInput(e)} required/>
						</div>
						<div className="col-xs-12 col-sm-1">
							<span className="span-min">F. Entrada</span>
							<MaskedFormControl type='text' name="entry_date" id="entry_date" 
								value={this.state.entry_date} 
								onChange={this.onDateChange} 
								onKeyPress={(e) => this.validateInput(e)} required
								mask='11/11/1111' placeholder="dd/mm/yyyy" className="form-control input-date" />
						</div>

						<div className="col-xs-12 col-sm-1">
							<span className="span-min">F. Donación</span>
							<MaskedFormControl type='text' name="donation_date" id="donation_date" 
								value={this.state.donation_date} 
								onChange={this.onDateChange} 
								onKeyPress={(e) => this.validateInput(e)} required
								mask='11/11/1111' placeholder="dd/mm/yyyy" className="form-control input-date" />

						</div>

						
						<div className="col-xs-12 col-sm-3">
							<span className="span-min">Tipo Donación</span>
							<select className="form-control" name="donation_type_id" id="donation_type_id"
								value={this.state.donation_type_id || ""} onChange={this.handleChange}
								onKeyPress={(e) => this.validateInput(e)} required>
								<option value="">Seleccione...</option>
								{this.state.list_donation_type.map((item, i)=>{
									return <option key={i} value={item.donation_type.id}>
										{item.lookup_value}
									</option>
								})}
							</select>
						</div>

						<div className="col-xs-12 col-sm-1">
							<span className="span-min">No. Unidad</span>
							<input type="text" className="form-control" name="unit_number" id="unit_number"
								value={this.state.unit_number} onChange={this.handleChange}
								onKeyPress={(e) => this.validateInput(e)} 
								disabled={this.state.don_edit_don_num === 'NO'}/>
						</div>

						<div className="col-xs-12 col-sm-1">
							<span className="span-min">No. Origen</span>
							<input type="text" className="form-control" name="origin_unit_number" id="origin_unit_number"
								value={this.state.origin_unit_number} onChange={this.handleChange}
								onKeyPress={(e) => this.validateInput(e)} />
						</div>

						
					</div>

					<div className="col-xs-12">
						
						<div className="col-xs-12 col-sm-3">
							<span className="span-min">Componente</span>
							<select className="form-control" name="component_id" id="component_id" value={this.state.component_id}
								onChange={this.handleChange} onKeyPress={(e) => this.validateInput(e)} required >
								<option value="">Seleccione...</option>
								{this.state.blood_component_list.map((item, i)=>{
									return <option key={i} value={item.component.id}>
										{item.component.component}
									</option>
								})}
							</select>
						</div>

						<div className="col-xs-12 col-sm-1">
							<span className="span-min" style={{fontSize:'13px'}}>No. Componente</span>
							
							<input type="text" className="form-control" name="component_number" id="component_number"
								value={this.state.component_number} onChange={this.handleChange}
								onKeyPress={(e) => this.validateInput(e)} required />
						</div>

						<div className="col-xs-12 col-sm-1">
							<span className="span-min">Grupo y RH</span>
							<select className="form-control" name="group_rh" id="group_rh" 
								value={this.state.group_rh}	onChange={this.handleChange} 
								onKeyPress={(e) => this.validateInput(e)} required>
								<option value="">Seleccione...</option>
								{this.state.blood_group.map((group, i)=>{
									return <option key={i} value={group.key_group+' '+group.key_rh}>
										{group.name}
									</option>
								})}
							</select>
						</div>
						<div className="col-xs-12 col-sm-1">
							<span className="span-min">Lectina</span>
							<select className="form-control" name="lectina" id="lectina" 
								value={this.state.lectina}	onChange={this.handleChange} 
								onKeyPress={(e) => this.validateInput(e)}
								disabled={this.state.disable_lect}>
								<option value="">Seleccione...</option>
								{this.state.lectina_list.map((l, i)=>(
									<option key={i} value={l}>{l}</option>
								))}
							</select>
						</div>
						<div className="col-xs-12 col-sm-1">
							<span className="span-min">DU</span>
							<select className="form-control" name="du" id="du" 
								value={this.state.du}	onChange={this.handleChange} 
								onKeyPress={(e) => this.validateInput(e)}
								disabled={this.state.disable_du}>
								<option value="">Seleccione...</option>
								{this.state.du_list.map((d, i)=>(
									<option key={i} value={d}>{d}</option>
								))}
							</select>
						</div>
						<div className="col-xs-12 col-sm-1">
							<span className="span-min">Volumen</span>
							<input type="text" className="form-control input-hour" name="volumen" id="volumen" 
								value={this.state.volumen} onChange={this.handleChange} 
								onKeyPress={(e) => this.validateInput(e)} required />
						</div>

						<div className="col-xs-12 col-sm-1">
							<span className="span-min" style={{fontSize:'12px'}}>Unidad Equivalente</span>
							<input type="text" className="form-control hour-input"  
								name="equivalet_unit" id="equivalet_unit" value={this.state.equivalet_unit}
								onChange={this.handleChange}
								onKeyPress={(e) => this.validateInput(e)} />
						</div>

						<div className="col-xs-12 col-sm-2">
							<span className="span-min">Fecha Caducidad</span>
							<MaskedFormControl type='text' name="caducidad" id="caducidad" 
								value={this.state.caducidad} 
								onChange={this.onDateChange} 
								onKeyPress={(e) => this.validateInput(e)} required
								mask='11/11/1111' placeholder="dd/mm/yyyy" className="form-control input-date" />

						</div>

						<div className="col-xs-12 col-sm-1">
							<span className="span-min">Hora</span>

							<input id="hour" name="hour" type="text" data-inputmask-alias="datetime" data-inputmask-inputformat="HH:MM"  
								data-inputmask-placeholder="-" value={this.state.hour || ""}
								className="form-control" onChange={this.handleChange} required />
						</div>
						

					</div>

					<div className="col-xs-12 form-group">
						<fieldset className="col-xs-12 col-sm-6">
							<legend>Datos de Donador</legend>
							<div className="col-xs-12 col-sm-4" style={{paddingLeft:'0'}}>
								<span className="span-min">Nombres</span>
								<input type="text" className="form-control" name="names" id="names"
									value={this.state.names} onChange={this.handleChange} 
									onKeyPress={(e) => this.validateInput(e)} required />
							</div>
							<div className="col-xs-12 col-sm-4" style={{paddingRight:'0'}}>
								<span className="span-min">Apellido Paterno</span>
								<input type="text" className="form-control" name="lastname1" id="lastname1"
									value={this.state.lastname1} onChange={this.handleChange} 
									onKeyPress={(e) => this.validateInput(e)} required />
							</div>
							<div className="col-xs-12 col-sm-4" style={{paddingRight:'0'}}>
								<span className="span-min">Apellido Materno</span>
								<input type="text" className="form-control" name="lastname2" id="lastname2"
									value={this.state.lastname2} onChange={this.handleChange} 
									onKeyPress={(e) => this.validateInput(e)} />
							</div>
						</fieldset>
						
						<fieldset className="col-xs-12 col-sm-6">
							<legend>Biometría Hemática</legend>

							{this.state.biometrics.map( (t, index) => (
								<div className="col-xs-12 col-sm-3" style={{padding:"2px 2px 2px 8px",overflow:"hidden"}} key={index}>
									<span className="size-min" style={{whiteSpace:"nowrap"}}>{t.name}</span>
									<input disabled={t.data_type === "BIO_D_CALCULATED" || (!this.props.task_biometrics.create && !this.props.task_biometrics.update)||this.state.exist_extraction} 
										className="form-control bio_extraction" name={'biometric_'+t.id.toString()} 
										step="0.01" type="number" min="0" maxLength={this.state.max_length}
										id={'biometric_'+t.id.toString()}
										onChange={(e) => this.calculateValuesBIO(e)}
										onKeyPress={(e) => this.validateInput(e)}
										 />
								</div>
							))}
						</fieldset>
					</div>

					{this.state.show_patient ?
						<div className="col-xs-12" style={{padding:"0px"}}>
							<PatientData setState={this.setState} 
				        		validate={this.validateInput}
								state={this.state} 
								onRef={ref => (this.patient = ref)}
								handleChange={this.handleChange} 
								selectFieldHandle={this.selectFieldHandle} 
								setInfoPatient={this.setInfoPatient}
								setInfoDonor={this.setInfoDonor}
								autocompleteHandle={this.autocompleteHandle}
								clearPatientSearch = {this.clearPatientSearch}/>
						</div>
					:null}

					<div className="col-xs-12 form-group">
						<div className="col-xs-12" style={{textAlign:'center'}}>
							<button type="button" className="btn btn-results" 
								disabled={this.state.require_phen === 'NO'}
								onClick={(e) => this.openModalPhenotype(e, 'phenotypes')}>
								Fenotipos
							</button>

							<button type="button" className="btn btn-results" 
								disabled={this.state.require_phen === 'NO'}
								onClick={(e) => this.openModalPhenotype(e, 'antibodies')}>
								Anticuerpos
							</button>
						</div>
					</div>

					<div className="col-xs-12 form-group">
						<div className="col-xs-12 col-sm-4">
							<span className="span-min">Observaciones</span>
							<textarea className="form-control" name="observations_unit" id="observations_unit"
								value={this.state.observations_unit} onChange={this.handleChange} style={{resize:"none"}} />
						</div>
						<div className="col-xs-12 col-sm-1">
							<button type="button" className="btn btn-info" style={{fontSize:'1em', marginTop:'2em'}}
								onClick={this.onSave}>
								{this.props.match.params.id === undefined ? 'Agregar' : 'Actualizar'}
							</button>
						</div>
					</div>

					{this.props.match.params.id === undefined &&
						<div className="col-xs-12">
							<Table responsive hover>
								<thead>
									<tr>
										<th>Donador</th>
										<th>No Unidad</th>
										<th>Componente</th>
										<th>No Componente</th>
										<th>Grupo & RH</th>
										<th>Fecha Donación</th>
										<th>Fecha Caducidad</th>
										<th>Volumen</th>
										<th></th>
									</tr>
								</thead>
								<tbody>
									{this.state.units_list.map((u, i)=>{
										return <tr>
											<td>{u.donor}</td>
											<td>{u.unit_number}</td>
											<td>{u.component}</td>
											<td>{u.component_number}</td>
											<td>{u.group_rh}</td>
											<td>{u.donation_date}</td>
											<td>{u.caducidad}</td>
											<td>{u.volume}</td>
											<td>
												<button type="button" className="btn btn-info" type="button" 
													onClick={this.deleteEntry.bind(this,i,u.id)} 
													onKeyPress={(e) => this.validateInput(e)} 
													>
													<SvgIcon icon={bin}/>
												</button>
											</td>
										</tr>
									})}
								</tbody>
							</Table>
						</div>
					}

					<fieldset className="col-xs-12">
						<legend>Pruebas Analiticas</legend>
						<div className="col-xs-12 col-sm-6 col-sm-offset-6">
							<div className="col-xs-12">
								<input type="checkbox" name="add_test" id="add_test"
									onChange={this.handleChange}  style={{margin:"0 5px"}} />
								<span>
									Agregar Pruebas
								</span>
							</div>
							{this.state.add_other_test ?
								<div className="col-xs-12">
									<div className="col-xs-12 col-sm-10">
										<span>Prueba</span>
										<select className="form-control" name="test_id" id="test_id"
											value={this.state.test_id} onChange={this.handleChange}>
											<option value="">Seleccione...</option>
											{this.state.other_test.map((item, i)=>{
												return <option key={i} value={item.analitical_test.id}>
													{item.analitical_test.name}
												</option>
											})}
										</select>
									</div>
									<div className="col-xs-12 col-sm-2">
										<FloatingActionButton className="action-btn"  mini={true}  onClick={this.addAnaliticalTest}>
								            <ContentAdd/>
								        </FloatingActionButton>
									</div>
								</div>
							: null}
								
						</div>
						<div className="col-xs-12 col-sm-6">
							<Table responsive hover>
								<thead>
									<tr>
										<th>Pruebas Obligatorias</th>

									</tr>
								</thead>
								<tbody>
									{this.state.analitical_test_list.map((item, i)=>{
										return <tr key={i}>
											<td>
												<div className="col-xs-12 col-sm-7">
													<input type="checkbox" id={item.checkbox.id} 
														checked={item.checkbox.checked} style={{margin:"0 7px"}} onChange={this.handleChange}/>
													{item.analitical_test.name}
												</div>
											</td>
										</tr>
									})}
								</tbody>
							</Table>
						</div>
						{this.state.add_other_test ? 
							<div className="col-xs-12 col-sm-6">
								<Table>
									<thead>
										<tr>
											<th colSpan="2">Otras Pruebas</th>
										</tr>
									</thead>
									<tbody>
										{this.state.table_other_test.map((item, i)=>{
											return <tr key={i}>
												<td>
													<div className="col-xs-12 col-sm-7">
														{item.analitical_test.name}
													</div>
												</td>
												<td>
													<button type="button" className="btn btn-info" type="button" onClick={this.deteleTest.bind(this,i)} 
														onKeyPress={(e) => this.validateInput(e)} 
														>
														<SvgIcon icon={bin}/>
													</button>
												</td>
											</tr>
										})}
									</tbody>
								</Table>
							</div>
						:null}
							
					</fieldset>
				</form>
				<div className="col-xs-12">
					
		        	<div className="col-xs-12" style={{textAlign:'center'}}>
		        		<RaisedButton className="action-btn" label={t('content.generics.buttons.finish')} primary={true} onClick={this.onFinish}  style={{margin:12}}/>
		        		<RaisedButton className="action-btn" label={t('content.generics.buttons.return')} primary={true} style={{margin:12}} onClick={this.onReturn}/>
		        	</div>
		        </div>

		        <Notifications />
				<ModalPhenotype 
					getFenotipoDonacion={this.getfenotipoAntibody} {...this.props} 
					onRef={ref => (this.modal_phenotype = ref)} 
					setValuesDistribution={this.SetPhenotypesAntibodies} 
					results={this.state.unit_entries_has_phenotypes}
				/>
				<ModalCenter {...this.props} onRef={ref => (this.modal_add_center = ref)} 
					refresh={this.getHealthFacilities} />
					
			</div>
		)
	}
}

export default translate('translations') (EntryUnits);
